import React, { useEffect, useState } from "react"
import {
    Button, Card, CardBody, Col, Container, Row, Pagination, PaginationItem, PaginationLink, Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Table
} from "reactstrap"
import PropTypes from "prop-types"
import { getChanges, editLocation, getAccountManagers, getCoreParkReports, getCoreParkTicketsReports, getLocation, getParkingTypes, getReportsForLocation, getThirdPartyPlatforms, getAllDailyProductReports } from "helpers/fakebackend_helper"
import EditLocationModal from "./EditLocationModal"
import { FILES_URL } from "helpers/url_helper"
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import TicketsMonthlyLineStatistic from "./TicketsMonthlyLineStatistic"
import FeeCards from "./FeeCards"
import formatCurrency from "constants/formatCurrency"
import LeasePayments from "./LeasePayments"
import FeeManager from "./FeeManager"
import CostManager from "./CostManager"
import DateRangeSelector from "components/Common/DateRangeSelector"
import moment from "moment"
import formatDate from "constants/formatDate"
import LocationHeaderCard from "./LocationHeaderCard"
import LocationTabs from "./LocationTabs"
import LocationWorkingHoursCard from "./LocationWorkingHoursCard"
import LocationCarSummaryCard from "./LocationCarSummaryCard"
import LocationLeasePaymentsCard from "./LocationLeasePaymentsCard"
import LocationEmployees from "./LocationEmployees"
import LocationOtherDetailsCard from "./LocationOtherDetailsCard"
import LocationParkingLots from "./LocationParkingLots"
import LocationFiles from "./LocationFiles"
import TransactionAnalysis from "./TransactionAnalysis"

const LocationDetails = () => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const navigate = useNavigate();
    const { lot_id } = useParams()
    const [searchParams] = useSearchParams();
    const [location, setLocation] = useState({})
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [accountManagers, setAccountManagers] = useState([])
    const [thirdPartyPlatforms, setThirdPartyPlatforms] = useState([])
    const [parkingTypes, setParkingTypes] = useState([])
    const [tickets, setTickets] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 5;
    const [orderPage, setOrderPage] = useState(1);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [loading, setLoading] = useState(false);
    const [openAccordion, setOpenAccordion] = useState("")
    const [changes, setChanges] = useState([])
    const [changesLoading, setChangesLoading] = useState(false)
    const [changeTypeFilter, setChangeTypeFilter] = useState("All")
    const [activeTab, setActiveTab] = useState("1")
    const [transactions, setTransactions] = useState([]);
    const [transactionsLoading, setTransactionsLoading] = useState(false);

    const toggleAccordion = (id) => {
        if (openAccordion === id) {
            setOpenAccordion("")
        } else {
            setOpenAccordion(id)
            if (id === "changes") loadChanges()
        }
    }

    const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);

    const loadTicketsForLocation = async (start, end) => {
        setLoading(true);
        setTransactionsLoading(true); // Start loading transactions
        try {
            const payload = {
                location_id: lot_id,
                start_date: start,
                end_date: end,
            };

            // 1. Fetch Existing Ticket Report
            const ticketsReq = getCoreParkTicketsReports(user.token, payload);

            // 2. Fetch New Transaction Data (The PHP function you made)
            // Note: Ensure getDailyProductTransactions matches your API definition
            const transactionsReq = getAllDailyProductReports(user.token, payload);

            const [ticketsRes, transactionsRes] = await Promise.all([ticketsReq, transactionsReq]);

            setTickets(ticketsRes.data.tickets);

            console.log("transactionsRes: ", transactionsRes)

            // Set the new data
            if (transactionsRes.data) {
                setTransactions(transactionsRes.data);
            }

        } catch (error) {
            console.error("Error loading reports", error);
        } finally {
            setLoading(false);
            setTransactionsLoading(false);
        }
    };

    const loadParkingTypes = async () => {
        const { data } = await getParkingTypes(user.token);
        setParkingTypes(data);
    }

    const loadThirdPartyPlatforms = async () => {
        const { data } = await getThirdPartyPlatforms(user.token);
        setThirdPartyPlatforms(data);
    }

    const loadLocationDetails = async () => {
        const { data } = await getLocation(user.token, lot_id);
        setLocation(data);
    };

    const loadAccountManagers = async () => {
        const { data } = await getAccountManagers(user.token);
        setAccountManagers(data);
    }

    const handleSave = async (formData) => {
        setIsSaving(true);
        try {
            await editLocation(user.token, lot_id, formData);
            await loadLocationDetails();
            toggleEditModal();
        } finally {
            setIsSaving(false);
        }
    };

    useEffect(() => {
        loadLocationDetails()
        loadAccountManagers()
        loadParkingTypes()
        loadThirdPartyPlatforms()
    }, [])

    if (!location) {
        return (
            <Container fluid>
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardBody>
                                <h5>No location found for ID: {lot_id}</h5>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }

    const loadChanges = async () => {
        setChangesLoading(true)
        try {
            const { data } = await getChanges(user.token, lot_id)
            if (data) setChanges(data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))
        } finally {
            setChangesLoading(false)
        }
    }

    // Handler to open modal for adding files (placeholder logic)
    const handleAddFile = (categoryKey) => {
        // You can set specific state here to tell the modal which file type to add
        console.log("Add file for:", categoryKey)
        toggleEditModal()
    }

    // Handler to delete file (placeholder logic)
    const handleDeleteFile = (fileId) => {
        if (window.confirm("Are you sure you want to delete this file?")) {
            console.log("Delete file:", fileId)
            // Call API to delete file, then reload location
            // await deleteFile(fileId)
            // loadLocationDetails()
        }
    }

    const isLeaseLocation = location.operating_structure === "Lease" || location.lease_amount > 0;

    return (
        <div className="page-content" style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}>
            <Container fluid>
                <Row className="mb-4">
                    <Col>
                        <Button
                            color="secondary"
                            onClick={() => {
                                const queryString = searchParams.toString();
                                navigate(queryString ? `/locations?${queryString}` : "/locations");
                            }}
                            className="d-flex align-items-center"
                        >
                            <i className="bx bx-arrow-back me-1"></i> Back
                        </Button>
                    </Col>
                </Row>

                <LocationHeaderCard
                    location={location}
                    toggleEditModal={toggleEditModal}
                />

                <LocationTabs
                    activeTab={activeTab}
                    toggleTab={setActiveTab}
                    isLease={isLeaseLocation}
                />

                {activeTab == "1" &&
                    <>
                        <Row className="mt-4 mb-4">
                            <Col lg={7} className="mb-3 mb-lg-0">
                                <LocationWorkingHoursCard
                                    hoursString={location.location_hours}
                                    onEdit={toggleEditModal}
                                />
                            </Col>
                            <Col lg={5}>
                                <LocationCarSummaryCard
                                    cars={location.cars}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xs={12}>
                                <LocationEmployees employees={location.employees} />
                            </Col>
                        </Row>
                        {/* TICKETS MONTHLY GRAPH */}
                        <Row className="mb-4">
                            <Col md={12}>
                                <Card className="accordion-gradient-border shadow-none text-white" style={{ backgroundColor: "#3C3C3C" }}>
                                    <h2 className="text-center mb-2 mt-2">Tickets</h2>
                                    <div className="mt-2">
                                        <DateRangeSelector
                                            showReload={true}
                                            onApply={(start, end) => {
                                                setDateRange({ start, end });
                                                setOrderPage(1);
                                                loadTicketsForLocation(start, end);
                                            }}
                                        />
                                    </div>

                                    {loading ? (
                                        <div className="text-center text-white py-5">Loading...</div>
                                    ) : tickets && Array.isArray(tickets) && tickets.length === 0 ? (
                                        <div className="text-center text-white py-5">
                                            <h5>No record found in this timerange.</h5>
                                        </div>
                                    ) : (
                                        <TicketsMonthlyLineStatistic tickets={tickets || []} />
                                    )}

                                    {lot_id == 101 &&
                                        <div className="mt-5 border-top border-secondary pt-4">
                                            <h4 className="text-white mb-4 text-center">Daily Product Transactions</h4>

                                            {transactionsLoading ? (
                                                <div className="text-center text-white">Loading Transactions...</div>
                                            ) : (
                                                <TransactionAnalysis transactions={transactions} />
                                            )}
                                        </div>
                                    }
                                </Card>
                            </Col>
                        </Row>
                    </>
                }
                {activeTab == "2" &&
                    <Row className="mt-4">
                        <Col md={12}>
                            {isLeaseLocation && (
                                <LocationLeasePaymentsCard
                                    locationId={lot_id}
                                    leaseAmount={location.lease_amount}
                                    payments={location.lease_payments}
                                    operation_hours={location.location_hours}
                                    handleSave={loadLocationDetails}
                                />
                            )}
                        </Col>
                    </Row>
                }
                {activeTab == "3" &&
                    <>
                        <Row className="mt-4">
                            <Col xs={8}>
                                <LocationParkingLots
                                    parkingLots={location.parking_lots}
                                    onAdd={toggleEditModal}
                                />
                            </Col>
                            <Col xs={4}>
                                <LocationOtherDetailsCard location={location} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xs={6}>
                                <FeeManager
                                    location_id={lot_id}
                                    location={location}
                                    fees={location.fees}
                                    handleSave={loadLocationDetails}
                                />
                            </Col>
                            <Col xs={6}>
                                <CostManager
                                    location_id={lot_id}
                                    location={location}
                                    costs={location.costs}
                                    handleSave={loadLocationDetails}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <FeeCards
                                billables={[
                                    { label: "Tech Fee", amount: parseFloat(location.tech_fee) || 0 },
                                    { label: "Ops Supplies Fee", amount: parseFloat(location.ops_supplies_fee) || 0 },
                                    { label: "Management Fee", amount: parseFloat(location.management_fee) || 0 },
                                    { label: "Insurance Fee", amount: parseFloat(location.insurance_fee) || 0 },
                                    { label: "Parking Lot Fee", amount: parseFloat(location.parking_lot_fee) || 0 },
                                    { label: "Permit/Meter Fee", amount: parseFloat(location.permit_meter_fee) || 0 },
                                    { label: "Lease Amount / day", amount: parseFloat(location.lease_amount) || 0 },
                                ].filter(f => f.amount && f.amount !== 0)}
                                billableTitle={"Fixed Revenues"}
                                payables={[
                                    { label: "Parking Lot Cost", amount: parseFloat(location.parking_lot_cost) || 0 },
                                    { label: "Partner Remittance Fee", amount: parseFloat(location.partner_remittance_fee) || 0 },
                                ].filter(f => f.amount && f.amount !== 0)}
                                payableTitle={"Fixed Expenses"}
                                sm={6}
                                md={6}
                            />
                        </Row>
                    </>
                }
                {activeTab == "4" &&
                    <div className="mt-4">
                        <LocationFiles
                            location={location}
                            onAddFile={handleAddFile}
                            onDeleteFile={handleDeleteFile}
                        />
                    </div>
                }
                {activeTab != "1" && activeTab != "2" && activeTab != "3" && activeTab != "4" &&
                    <></>
                    // <>
                    //     {/* Address / Hours / Spaces */}
                    //     <Card className="shadow-none accordion-gradient-border">
                    //         <CardBody>
                    //             <Row className="mb-4">
                    //                 <Col md={6}>
                    //                     <h6>Address</h6>
                    //                     <p className="mb-0">{location.location_address}</p>
                    //                 </Col>
                    //                 <Col md={6}>
                    //                     <h6>Hours</h6>
                    //                     <p className="mb-0" style={{ whiteSpace: "pre-line" }}>{location.location_hours}</p>
                    //                 </Col>
                    //             </Row>
                    //         </CardBody>
                    //     </Card>

                    //     <Accordion open={openAccordion} toggle={toggleAccordion} className="mb-4">
                    //         <AccordionItem>
                    //             <AccordionHeader className="accordion-gradient-border" targetId="files">Files</AccordionHeader>
                    //             <AccordionBody accordionId="files">
                    //                 {/* Files / Partnership Remittance */}
                    //                 <Row className="mb-4">
                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Contract Files</h6>
                    //                                 {location.contract_files && location.contract_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.contract_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Amendment Files</h6>
                    //                                 {location.amendment_files && location.amendment_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.amendment_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Logo Files</h6>
                    //                                 {location.logo_files && location.logo_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.logo_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>COI Files</h6>
                    //                                 {location.coi_files && location.coi_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.coi_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Business Licence Files</h6>
                    //                                 {location.business_licence_files && location.business_licence_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.business_licence_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>City Document Files</h6>
                    //                                 {location.city_document_files && location.city_document_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.city_document_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Receipt Files</h6>
                    //                                 {location.receipt_files && location.receipt_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.receipt_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Signage Files</h6>
                    //                                 {location.signage_files && location.signage_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.signage_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Team Pic Files</h6>
                    //                                 {location.team_pic_files && location.team_pic_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.team_pic_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Marketing Pic Files</h6>
                    //                                 {location.marketing_pic_files && location.marketing_pic_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.marketing_pic_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Other Files</h6>
                    //                                 {location.other_files && location.other_files.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.other_files.map((file, idx) => (
                    //                                             <li key={idx}>
                    //                                                 <a href={`${FILES_URL}${file.file_name}`} target="_blank" rel="noopener noreferrer">
                    //                                                     Click here
                    //                                                 </a>
                    //                                             </li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No files</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                 </Row>
                    //             </AccordionBody>
                    //             <AccordionHeader className="accordion-gradient-border" targetId="parking_lots">Parking Lots</AccordionHeader>
                    //             <AccordionBody accordionId="parking_lots">
                    //                 {/* Parking Lot Details */}
                    //                 {location.parking_lots && location.parking_lots.map((lot, index) => (
                    //                     <Card className="border shadow-none mb-4" key={index}>
                    //                         <div className="card-header" style={{ background: "#000000", color: "#ffffff" }}>
                    //                             <h5 className="mb-0">Parking Lot #{index + 1}</h5>
                    //                         </div>
                    //                         <CardBody>
                    //                             <Row className="mb-4">
                    //                                 <Col md={3}>
                    //                                     <h6>Type</h6>
                    //                                     <p className="mb-0">{lot.type}</p>
                    //                                 </Col>
                    //                                 <Col md={3}>
                    //                                     <h6>Access Hours</h6>
                    //                                     <p className="mb-0" style={{ whiteSpace: "pre-line" }}>{lot.access_hours}</p>
                    //                                 </Col>
                    //                                 <Col md={3}>
                    //                                     <h6>Rent Amount</h6>
                    //                                     <p className="mb-0">${lot.rent_amount}</p>
                    //                                 </Col>
                    //                                 <Col md={3}>
                    //                                     <h6>Due Date</h6>
                    //                                     <p className="mb-0">{lot.due_date}</p>
                    //                                 </Col>
                    //                             </Row>
                    //                             <Row className="mb-4">
                    //                                 <Col md={3}>
                    //                                     <h6>Payee Name</h6>
                    //                                     <p className="mb-0">{lot.payee_name}</p>
                    //                                 </Col>
                    //                                 <Col md={3}>
                    //                                     <h6>Payee Email</h6>
                    //                                     <p className="mb-0">{lot.payee_email}</p>
                    //                                 </Col>
                    //                                 <Col md={2}>
                    //                                     <h6>Payee Phone</h6>
                    //                                     <p className="mb-0">{lot.payee_phone}</p>
                    //                                 </Col>
                    //                                 <Col md={2}>
                    //                                     <h6>Spaces</h6>
                    //                                     <p className="mb-0">{lot.spaces}</p>
                    //                                 </Col>
                    //                                 <Col md={2}>
                    //                                     <h6>Rules</h6>
                    //                                     <p className="mb-0" style={{ whiteSpace: "pre-line" }}>{lot.rules}</p>
                    //                                 </Col>
                    //                             </Row>
                    //                         </CardBody>
                    //                     </Card>
                    //                 ))}
                    //             </AccordionBody>
                    //             <AccordionHeader className="accordion-gradient-border" targetId="other_details">Other Details</AccordionHeader>
                    //             <AccordionBody accordionId="other_details">
                    //                 {/* Labor Hours Cap / Invoice Directives / Labor Rates */}
                    //                 <Row className="mb-4">
                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Labor Hours Cap</h6>
                    //                                 <p className="mb-0">{location.labor_hours_cap} hours</p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Spaces</h6>
                    //                                 <p className="mb-0">{location.location_spaces}</p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Manager Labor Rate</h6>
                    //                                 <p className="mb-0">${location.manager_labor_rate}/hr</p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                     <Col md={3}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Attendant Labor Rate</h6>
                    //                                 <p className="mb-0">${location.attendant_labor_rate}/hr</p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                     <Col md={4}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Partner Remittance Terms</h6>
                    //                                 <p className="mb-0">
                    //                                     {location.partner_remittance_terms}{" - "}
                    //                                     {location.partner_remittance_amount > 0
                    //                                         ? `$${location.partner_remittance_amount}`
                    //                                         : location.partner_remittance_percent > 0
                    //                                             ? `${location.partner_remittance_percent}%`
                    //                                             : ""}
                    //                                 </p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                     <Col md={4}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Accounting Notes</h6>
                    //                                 {location.finance_terms && location.finance_terms.length > 0 ? (
                    //                                     <ul className="mb-0 ps-3">
                    //                                         {location.finance_terms.map((term, idx) => (
                    //                                             <li key={idx}>{term.term}</li>
                    //                                         ))}
                    //                                     </ul>
                    //                                 ) : (
                    //                                     <p className="mb-0">No notes</p>
                    //                                 )}
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>

                    //                     <Col md={4}>
                    //                         <Card className="border shadow-none">
                    //                             <CardBody>
                    //                                 <h6>Invoice Directives</h6>
                    //                                 <p className="mb-0">{location.invoice_directives}</p>
                    //                             </CardBody>
                    //                         </Card>
                    //                     </Col>
                    //                 </Row>
                    //             </AccordionBody>
                    //             {(location.operating_structure == "Lease" || location.lease_amount > 0) &&
                    //                 <>
                    //                     <AccordionHeader className="accordion-gradient-border" targetId="lease_payments">Lease Payments</AccordionHeader>
                    //                     <AccordionBody accordionId="lease_payments">
                    //                         {/* Lease Payments */}
                    //                         <Row className="mb-4">
                    //                             <Col md={12}>
                    //                                 <LeasePayments
                    //                                     location_id={lot_id}
                    //                                     lease_amount={location.lease_amount}
                    //                                     operation_hours={location.location_hours}
                    //                                     payments={location.lease_payments}
                    //                                     handleSave={loadLocationDetails}
                    //                                 />
                    //                             </Col>
                    //                         </Row>
                    //                     </AccordionBody>
                    //                 </>
                    //             }
                    //             <AccordionHeader className="accordion-gradient-border" targetId="fees">Fees/Billables</AccordionHeader>
                    //             <AccordionBody accordionId="fees">
                    //                 {/* Fee Manager */}
                    //                 <Row className="mb-4">
                    //                     <Col md={12}>
                    //                         <FeeManager
                    //                             location_id={lot_id}
                    //                             location={location}
                    //                             fees={location.fees}
                    //                             handleSave={loadLocationDetails}
                    //                         />
                    //                     </Col>
                    //                 </Row>
                    //             </AccordionBody>
                    //             <AccordionHeader className="accordion-gradient-border" targetId="costs">Costs/Payables</AccordionHeader>
                    //             <AccordionBody accordionId="costs">
                    //                 {/* Cost Manager */}
                    //                 <Row className="mb-4">
                    //                     <Col md={12}>
                    //                         <CostManager
                    //                             location_id={lot_id}
                    //                             location={location}
                    //                             costs={location.costs}
                    //                             handleSave={loadLocationDetails}
                    //                         />
                    //                     </Col>
                    //                 </Row>
                    //             </AccordionBody>
                    //             <AccordionHeader className="accordion-gradient-border" targetId="changes">Changes</AccordionHeader>
                    //             <AccordionBody accordionId="changes">
                    //                 <Row className="mb-4">
                    //                     <Col md={3}>
                    //                         <select
                    //                             className="form-select form-select-sm w-100 accordion-gradient-border"
                    //                             value={changeTypeFilter}
                    //                             onChange={e => setChangeTypeFilter(e.target.value)}
                    //                         >
                    //                             <option>All</option>
                    //                             {[...new Set(changes.map(c => c.type))].map((t, i) => (
                    //                                 <option key={i}>{t}</option>
                    //                             ))}
                    //                         </select>
                    //                     </Col>
                    //                 </Row>

                    //                 {changesLoading ? (
                    //                     <div className="text-center py-5">
                    //                         <div className="spinner-border text-primary" role="status" />
                    //                     </div>
                    //                 ) : changes.length === 0 ? (
                    //                     <div className="text-center py-4">No changes found.</div>
                    //                 ) : (
                    //                     <Table bordered responsive className="mb-0">
                    //                         <thead className="table-light">
                    //                             <tr>
                    //                                 <th>Created At</th>
                    //                                 <th>Affected Date</th>
                    //                                 <th>Changed By</th>
                    //                                 <th>Type</th>
                    //                                 <th>What Happened?</th>
                    //                                 <th>Note</th>
                    //                             </tr>
                    //                         </thead>
                    //                         <tbody>
                    //                             {changes
                    //                                 .filter(c => changeTypeFilter === "All" || c.type === changeTypeFilter)
                    //                                 .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    //                                 .map((c, idx) => (
                    //                                     <tr key={idx}>
                    //                                         <td>{formatDate(moment(c.created_at).format("YYYY-MM-DD HH:mm"))}</td>
                    //                                         <td>{c.affected_date ? formatDate(moment(c.affected_date).format("YYYY-MM-DD")) : "-"}</td>
                    //                                         <td>{c.user?.full_name || "-"}</td>
                    //                                         <td>{c.type}</td>
                    //                                         <td>{c.what_happened || "-"}</td>
                    //                                         <td>{c.note || "-"}</td>
                    //                                     </tr>
                    //                                 ))}
                    //                         </tbody>
                    //                     </Table>
                    //                 )}
                    //             </AccordionBody>
                    //         </AccordionItem>
                    //     </Accordion>

                    //     <FeeCards
                    //         billables={[
                    //             { label: "Tech Fee", amount: parseFloat(location.tech_fee) || 0 },
                    //             { label: "Ops Supplies Fee", amount: parseFloat(location.ops_supplies_fee) || 0 },
                    //             { label: "Management Fee", amount: parseFloat(location.management_fee) || 0 },
                    //             { label: "Insurance Fee", amount: parseFloat(location.insurance_fee) || 0 },
                    //             { label: "Parking Lot Fee", amount: parseFloat(location.parking_lot_fee) || 0 },
                    //             { label: "Permit/Meter Fee", amount: parseFloat(location.permit_meter_fee) || 0 },
                    //             { label: "Lease Amount / day", amount: parseFloat(location.lease_amount) || 0 },
                    //         ].filter(f => f.amount && f.amount !== 0)}
                    //         billableTitle={"Fixed Revenues"}
                    //         payables={[
                    //             { label: "Parking Lot Cost", amount: parseFloat(location.parking_lot_cost) || 0 },
                    //             { label: "Partner Remittance Fee", amount: parseFloat(location.partner_remittance_fee) || 0 },
                    //         ].filter(f => f.amount && f.amount !== 0)}
                    //         payableTitle={"Fixed Expenses"}
                    //         sm={6}
                    //         md={6}
                    //     />

                    //     {/* STAFF / CARS */}
                    //     <Row className="mb-4">
                    //         {location.cars &&
                    //             (location.cars.parked_this_year !== 0 ||
                    //                 location.cars.parked_this_week !== 0 ||
                    //                 location.cars.parked_this_month !== 0) && (
                    //                 <Col md={6}>
                    //                     <Card className="accordion-gradient-border shadow-none">
                    //                         <CardBody>
                    //                             <h6>Cars</h6>
                    //                             <Row>
                    //                                 <Col xs={12} className="text-center mb-4">
                    //                                     <h4>{location.cars.parked_this_week}</h4>
                    //                                     <p className="mb-0">PARKED THIS WEEK</p>
                    //                                 </Col>
                    //                                 <Col xs={12} className="text-center mb-4">
                    //                                     <h4>{location.cars.parked_this_month}</h4>
                    //                                     <p className="mb-0">PARKED THIS MONTH</p>
                    //                                 </Col>
                    //                                 <Col xs={12} className="text-center">
                    //                                     <h4>{location.cars.parked_this_year}</h4>
                    //                                     <p className="mb-0">PARKED THIS YEAR</p>
                    //                                 </Col>
                    //                             </Row>
                    //                         </CardBody>
                    //                     </Card>
                    //                 </Col>
                    //             )}

                    //         {location.employees && location.employees.length > 0 && (
                    //             <Col md={6}>
                    //                 <Card className="accordion-gradient-border shadow-none">
                    //                     <CardBody>
                    //                         <Table className="table mb-0" responsive>
                    //                             <thead>
                    //                                 <tr>
                    //                                     <th>Employee</th>
                    //                                     <th>Status</th>
                    //                                     <th>Payment Type</th>
                    //                                     <th>Hours This Month</th>
                    //                                 </tr>
                    //                             </thead>
                    //                             <tbody>
                    //                                 {location.employees
                    //                                     .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                    //                                     .map((s, idx) => {
                    //                                         const totalHours = s.user?.shift_entries
                    //                                             ? s.user.shift_entries.reduce(
                    //                                                 (sum, se) => sum + (parseFloat(se.net_hours) || 0),
                    //                                                 0
                    //                                             )
                    //                                             : 0;

                    //                                         // pick one shift (first one is enough)
                    //                                         const oneShift = s.user?.shift_entries?.[0];
                    //                                         let paymentType = "1099";
                    //                                         if (oneShift && oneShift.payment_type && oneShift.payment_type !== "1099") {
                    //                                             paymentType = "W2";
                    //                                         }

                    //                                         return (
                    //                                             <tr key={idx}>
                    //                                                 <td>{s.user?.full_name || s.user?.employee_alias}</td>
                    //                                                 <td>
                    //                                                     <span
                    //                                                         className={`badge ${s.is_active === 1
                    //                                                             ? "bg-success-subtle text-success"
                    //                                                             : "bg-secondary-subtle text-muted"
                    //                                                             }`}
                    //                                                     >
                    //                                                         {s.is_active === 1 ? "Active" : "Passive"}
                    //                                                     </span>
                    //                                                 </td>
                    //                                                 <td>{paymentType}</td>
                    //                                                 <td>{totalHours.toFixed(2)}</td>
                    //                                             </tr>
                    //                                         );
                    //                                     })}
                    //                             </tbody>
                    //                         </Table>

                    //                         {/* Pagination */}
                    //                         {location.employees.length > pageSize && (
                    //                             <Pagination className="mt-2">
                    //                                 {[...Array(Math.ceil(location.employees.length / pageSize))].map(
                    //                                     (_, pageIdx) => (
                    //                                         <PaginationItem
                    //                                             key={pageIdx}
                    //                                             active={currentPage === pageIdx + 1}
                    //                                         >
                    //                                             <PaginationLink onClick={() => setCurrentPage(pageIdx + 1)}>
                    //                                                 {pageIdx + 1}
                    //                                             </PaginationLink>
                    //                                         </PaginationItem>
                    //                                     )
                    //                                 )}
                    //                             </Pagination>
                    //                         )}
                    //                     </CardBody>
                    //                 </Card>
                    //             </Col>
                    //         )}
                    //     </Row>
                    // </>
                }
            </Container >

            <EditLocationModal
                isOpen={isEditModalOpen}
                toggle={toggleEditModal}
                location={location}
                handleSave={handleSave}
                isSaving={isSaving}
                accountManagers={accountManagers}
                thirdPartyPlatforms={thirdPartyPlatforms}
                parkingTypes={parkingTypes}
            />
        </div>
    )
}

LocationDetails.propTypes = {
    lot: PropTypes.object
}

export default LocationDetails